import { get, omitBy } from 'lodash-es';
import type { CoreTypes } from '../../core';
import type { Person } from '../types/persons';

const SexMap: Record<NonNullable<Person['sex']>, CoreTypes.Deep.Person['sex']> = { Man: 'Man', Kvinna: 'Woman', Okänt: undefined };
const TypeMap: Record<
  NonNullable<
    Person['phoneNumbers']
  >[0]['type'],
  NonNullable<
    CoreTypes.Deep.Person['phoneNumbers']
  >[0]['type']
> = {
  'Privat':         'private',
  'Hem':            'private',
  'Arbete övrigt':  'organization',
  'Arbete':         'organization',
  'Skola elev':     'organization',
  'Skola personal': 'organization'
};

export default (groups: Person[]): CoreTypes.MixedWithoutInternalId.Person[] => {
  if (!Array.isArray(groups))
    throw new Error('(SS12000::From::Person) Person input is not of array type', { cause: 'invalid_input' });

  return groups
    .map((person): CoreTypes.MixedWithoutInternalId.Person => ({
      ids:         person.id,
      displayName: person.displayName,
      type:        'Student',
      ...omitBy({
        sex:          person.sex ? get(SexMap, person.sex, undefined) : undefined,
        displayName:  person.displayName,
        firstName:    person.givenName,
        lastName:     person.familyName,
        SSN:          person.civicNo,
        emails:       person.emails?.map(({ type, ...arg }) => ({ type: get(TypeMap, type, undefined), ...arg })),
        phoneNumbers: person.phoneNumbers?.map(({ type, ...arg }) => ({ type: get(TypeMap, type, undefined), ...arg })),
      }, x => x == null)
    }));
};